import { render, staticRenderFns } from "./RiskDetail.vue?vue&type=template&id=3b0f4406&"
import script from "./RiskDetail.vue?vue&type=script&lang=js&"
export * from "./RiskDetail.vue?vue&type=script&lang=js&"
import style0 from "./RiskDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports